import React, { useState, useEffect } from 'react';
import { useGlobalState } from 'state-pool';

import Note from '../../../components/note';
import Label from '../../../components/label';
import FilterButton from '../../../components/filter-button';
import LinkButton from '../../../components/link-button';
import { getData } from '../../../helper/request-response';
import LoaderType from '../../../components/loader-type';
import paymentPath from './config';

const List = () => {

    const [rows, ,] = useGlobalState('rows');

    const [isLoad, setIsLoad] = useState(true);

    const [payment, setPayment] = useState([]);

    const [paymentFilter, setPaymentFilter] = useState({
        'name': ''
    });

    const getDetailPath = (id) => paymentPath.detail.replace(':id', id);

    const onFilterChange = e => {

        const { name, value } = e.target;

        setPaymentFilter(filter => ({ 
            ...filter,
            [name]: value
        }));
    };

    const onSubmit = e => {

        e.preventDefault();

        const params = { 
            'params': { 
                'name': paymentFilter.name,
                'rows': rows
            } 
        };

        getCoa(params);

    }

    const getCoa = async(params) => {

        setIsLoad(true);

        const result = await getData(paymentPath.api, params);

        setPayment(result);

        setIsLoad(false);

    }

    const onReset = (e) => {

        e.preventDefault();

        setPaymentFilter(filter => ({
            ...filter,
            'name': ''
        }));

        getCoa();

    }

    useEffect(() => { getCoa({ 'params': { 'rows': rows } }) }, [rows]);

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{paymentPath.title}</h3>
            </div>
            <div className="card-body">
                <div className="row">

                    <div className="col-md-8 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) }>
                            <div className="form-group row">
                                <Label htmlFor="payment-name" isCol={ true } text="Nama Metode Pembayaran" />
                                <div className="col-md-9">
                                    <input 
                                        id="payment-name" 
                                        type="text" 
                                        className="form-control"
                                        name="name"
                                        value={paymentFilter.name}
                                        onChange={ e => onFilterChange(e) } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } />
                                <div className="col-md-9">
                                    <FilterButton to={ paymentPath.new } newLabel="Tambah Metode Pembayaran Baru" onClick={ onReset } />
                                </div>
                            </div>

                        </form>
                    </div>
                    <div className="col-md-4">
                        <Note isFilter={ true } label="Tambah Metode Pembayaran Baru" entity="Payment" />
                    </div>
                </div>

                <br />
                { isLoad && <LoaderType /> }
                {
                    !isLoad &&
                    <div className="row">
                        <div className="col-lg-12 mb-4">
                            <div className="table-responsive">
                                <table className="table table-striped table-hover card-text">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Nama</th>
                                            <th>Opsi</th>
                                        </tr>
                                    </thead>
                                    {
                                        payment.length > 0 &&
                                        <tbody>
                                            {
                                                payment.map((item, index) => {
                                                    return(
                                                        <tr key={index}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>{item.name}</td>
                                                            <td><LinkButton to={ {pathname: getDetailPath(item.id), state: item} } /></td>
                                                        </tr>
                                                    );
                                                })
                                            }
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                    </div> 
                }
            </div>
        </React.Fragment>
    );
};

export default List;
